<template>
  <div>
    <h1>Registrierung bestätigen</h1>

    <el-card v-if="confirmStatus === $config.status.ERROR">
      <el-alert
        :closable="false"
        show-icon
        title="Ihre E-Mail-Adresse konnte nicht bestätigt werden. Wahrscheinlich wurde der Registrierungs-Link bereits verwendet."
        type="error"
      />
    </el-card>

    <c-button-link
      round
      :to="{ name: 'login' }"
      type="primary"
    >
      Zum Login
    </c-button-link>

    <c-button-link
      round
      :to="{ name: 'signup' }"
    >
      Zur Registrierung
    </c-button-link>
  </div>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'

import api from '@/api'
import LoadingOverlay from '@/functions/LoadingOverlay'

export default {
  name: 'VSignupConfirm',

  metaInfo: {
    title: 'Registrierung bestätigen'
  },

  components: {
    CButtonLink
  },

  props: {
    token: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      confirmStatus: this.$config.status.IDLE
    }
  },

  created () {
    this.confirm()
  },

  methods: {
    confirm () {
      const loadingOverlay = new LoadingOverlay()
      loadingOverlay.start()

      this.confirmStatus = this.$config.status.LOADING

      api.signup
        .confirmAccount({
          token: this.token
        })
        .then(() => {
          // Change route first
          this.$router.push({ name: 'login' })
          this.confirmStatus = this.$config.status.SUCCESS

          // Alert second
          // This prevents the global beforeEach to clear the alert
          this.$store.commit('global/alert', {
            show: true,
            title: 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt. Sie können sich nun mit Ihren Kontodaten anmelden.',
            type: 'success'
          })
        })
        .catch(() => {
          this.confirmStatus = this.$config.status.ERROR
        })
        .finally(() => {
          loadingOverlay.stop()
        })
    }
  }
}
</script>
